import React from 'react';
import {logger} from '../helperFunctions';
import {equals, set} from 'ramda';
import {
  fetchAccount as fetchAccountAPI,
  updateAccount as updateAccountAPI,
  updateAddress as updateAddressAPI
} from '../Api';
import {scope} from '../settings';

const useAccount = ({loading, setLoading, authAndContent}) => {
  const [account, setAccount] = React.useState(null);

  React.useEffect(() => {
    if (authAndContent.token?.accessToken) {
      fetchAccount();
      return;
    }

    setAccount(null);
  }, [authAndContent.token]); // eslint-disable-line

  React.useEffect(() => {
    window.account = account;
  }, [account]);

  const fetchAccount = React.useCallback(
    async (force, count = 0) => {
      if (!force && loading) {
        return;
      }

      if (!loading) {
        setLoading(true);
      }

      return authAndContent.getValidToken().then(newToken =>
        fetchAccountAPI(newToken)
          .then(ret => {
            if (!ret || ret.errors) {
              authAndContent.showError(ret.errors, 'fetchAccount failed');
              logger('fetchAccount failed: ', ret);
              setLoading(false);
              return ret;
            }
            // if account didn't change, check again after 500ms, do this up to 5 times
            if (equals(account, ret) && count < 5) {
              return setTimeout(fetchAccount(force, count + 1), 500);
            }
            setAccount(ret);
            setLoading(false);
            return ret;
          })
          .catch(err => {
            logger(err);
            authAndContent.showError(err, 'Unknown Failure');
            setLoading(false);
            return err;
          })
      );
    },
    [authAndContent.getValidToken] // eslint-disable-line
  );

  const updateAccount = async newAccount => {
    setLoading(true);
    return authAndContent.getValidToken().then(newToken =>
      updateAccountAPI(newToken, newAccount).then(ret => {
        setLoading(false);
        if (ret?.errors) {
          return ret;
        }
        return fetchAccount();
      })
    );
  };

  const updateAddress = async account => {
    setLoading(true);
    return updateAddressAPI(scope, account).then(ret => {
      setLoading(false);
      if (ret?.errors) {
        return ret;
      }
      return authAndContent.token ? fetchAccount() : null;
    });
  };

  return {account, setAccount, fetchAccount, updateAccount, updateAddress};
};

export default useAccount;
